import { render, staticRenderFns } from "./CompanyLoginSolid.vue?vue&type=template&id=2a876d3e&scoped=true&"
import script from "./CompanyLoginSolid.vue?vue&type=script&lang=js&"
export * from "./CompanyLoginSolid.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLoginSolid.vue?vue&type=style&index=0&id=2a876d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a876d3e",
  null
  
)

export default component.exports